module.exports = __webpack_public_path__ + "img/hklhc_icon.bc50a121.png";